import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'


window.isMobileBrowser = function () {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Check for common mobile operating systems and devices
  if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
    return true
  }

  // As a fallback, check for touch screen capabilities
  // This is a more robust check as user agent sniffing can be unreliable
  if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
    return true
  }

  return false
}

window.renderTailGallery = function () {
  
}

window.collapseFacets = function () {
  const facetGroups = document.querySelectorAll('.facet-group')

  var expandedFiltersCookie = getCookie('bronewik_facets_exp')
  if (expandedFiltersCookie) {
    var expandedFilters = expandedFiltersCookie.split(',')
  } else {
    var expandedFilters = []
  }
  
  facetGroups.forEach(facetGroup => {
    var collapseToggle = facetGroup.querySelectorAll('.facet-group__name')[0]
    var collapseContent = facetGroup.querySelectorAll('.facet-group__fields')[0]

    var facetGroup = collapseToggle.parentElement.getAttribute("data-name")

    if (expandedFilters.indexOf(facetGroup) > -1) {
      collapseToggle.classList.add('facet-group__name--expanded')
      collapseContent.classList.add('facet-group__fields--expanded')
    }

    collapseToggle.addEventListener('click', () => {

      if (collapseToggle.classList.contains('facet-group__name--expanded')) {
        collapseToggle.classList.remove('facet-group__name--expanded')
        collapseContent.classList.remove('facet-group__fields--expanded')

        var existExpandedIndex = expandedFilters.indexOf(facetGroup)

        if (existExpandedIndex > -1) {
          expandedFilters.splice(existExpandedIndex, 1)
        }

      } else {
        collapseToggle.classList.add('facet-group__name--expanded')
        collapseContent.classList.add('facet-group__fields--expanded')
        expandedFilters.push(collapseToggle.parentElement.getAttribute("data-name"))
      }

      setCookie('bronewik_facets_exp', expandedFilters.join(','), 1)

    })
  })
}

window.collapseCatalogChildren = function () {
  const listsForCollapse = document.querySelectorAll('ul.children-tail')

  listsForCollapse.forEach(collapseElement => {
    var liElements = collapseElement.querySelectorAll('li')
    if (liElements.length > 3) {
      var ind = 0
      liElements.forEach(elementLi => {
        ind++
        if (ind > 3) {
          elementLi.classList.add('hidden')
        }
      })

      var moreBtn = document.createElement('button')
      moreBtn.classList.add('btn', 'btn-outline', 'btn-outline--tertiary', 'children-tail__expand-btn')
      moreBtn.innerHTML = 'Раскрыть'

      moreBtn.addEventListener('click', () => {

        if (moreBtn.classList.contains('children-tail__expand-btn--expanded')) {
          var ind = 0
          liElements.forEach(elementLi => {
            ind++
            if (ind > 3) {
              elementLi.classList.add('hidden')
            }
          })
          moreBtn.classList.remove('children-tail__expand-btn--expanded')
          moreBtn.innerHTML = 'Раскрыть'
        } else {
          liElements.forEach(elementLi => {
            if (elementLi.classList.contains('hidden')) {
              elementLi.classList.remove('hidden')
            }
          })
          moreBtn.classList.add('children-tail__expand-btn--expanded')
          moreBtn.innerHTML = 'Свернуть'
        }

        

      })

      collapseElement.insertAdjacentElement('afterend', moreBtn)

    }
  })
}

window.getHoversMenu = function () {

  const submenuControllers = document.querySelectorAll('[data-toggle="hover-submenu"]')

  submenuControllers.forEach((toggleElement) => {

    if (window.innerWidth < 576) {

      var moreBtn = null

      toggleElement.addEventListener("click", (event) => {
        event.preventDefault()

        var dataContent = []

        var dataSelector = toggleElement.getAttribute("data-target")
        var dataElements = document.querySelectorAll(dataSelector)

        if (toggleElement.classList.contains('mobile-active')) {

          toggleElement.classList.remove('mobile-active', 'category-item--active', 'category-item--carret-down')
          var dataForDelete = toggleElement.parentElement.querySelectorAll(dataSelector)
          
          dataForDelete.forEach(element => {
            element.classList.remove('shown')
            element.classList.add('hidden')
          })

          if (moreBtn) {
            moreBtn.remove()
          }

        } else {
          dataElements.forEach(element => {
            dataContent.push(element)
          })

          moreBtn = document.createElement('a')
          moreBtn.innerHTML = 'Весь список'
          moreBtn.href = toggleElement.href
          moreBtn.classList.add('btn', 'btn-outline', 'btn-outline--secondary', 'product-categories__more-btn')

          toggleElement.parentElement.appendChild(moreBtn)
          toggleElement.parentElement.appendChild(dataContent[0])

          dataContent[0].classList.add('shown')

          submenuControllers.forEach(element => {
            element.classList.remove('category-item--active', 'category-item--carret-down')
          })

          toggleElement.classList.add('mobile-active', 'category-item--active', 'category-item--carret-down')
        }

      })
    }

    toggleElement.addEventListener("mouseover", () => {

      var forHide = document.querySelectorAll('.catalog-subcategory')

      forHide.forEach(element => {
        element.classList.remove("shown")
        element.classList.add("hidden")
      })

      submenuControllers.forEach(element => {
        element.classList.remove('category-item--active')
      })

      toggleElement.classList.add('category-item--active')

      var dataSelector = toggleElement.getAttribute("data-target")
      var dataElements = document.querySelectorAll(dataSelector)

      dataElements.forEach((dataElement) => {
        dataElement.classList.remove("hidden")
        dataElement.classList.add("shown")
      })
    })
  })
}


window.getDropdowns = function() {

  const openElements = document.querySelectorAll('[data-toggle="show-dropdown"]')

  openElements.forEach((toggleElement) => {
    toggleElement.addEventListener("click", () => {
      var windowSelector = toggleElement.getAttribute("data-target")
      var windowElements = document.querySelectorAll(windowSelector)

      windowElements.forEach((windowElement) => {
        windowElement.classList.remove("hidden")
        windowElement.classList.add("shown")
      })

      var scrollingElement = windowElements[0]
      scrollingElement.scrollIntoView()
      
    })
  })

  const closeElements = document.querySelectorAll('[data-close="dropdown"]')

  closeElements.forEach((closeElement) => {
    closeElement.addEventListener("click", () => {
      var goalElementSelector = closeElement.getAttribute("data-target")
      var goalElements = document.querySelectorAll(goalElementSelector)

      goalElements.forEach((dropdownItem) => {
        dropdownItem.classList.remove("shown")
        dropdownItem.classList.add("hidden")
      })

    })
  })
}

window.getCollapses = function () {
  const collapseLists = document.querySelectorAll('[data-my-toggle="collapse-list"]')

  collapseLists.forEach((listItem) => {
    var toggleSelector = listItem.getAttribute("data-my-target")
    var className = `${toggleSelector.slice(1, toggleSelector.length)}--expanded`
    var clickItems = listItem.querySelectorAll(toggleSelector)

    clickItems.forEach((elementItem) => {
      elementItem.addEventListener("click", () => {
        if (elementItem.classList.contains(className)) {
          elementItem.classList.remove(className)
        }
        else {
          elementItem.classList.add(className)
        }

      })
    })
  })
}


document.addEventListener('DOMContentLoaded', () => {
  const relatedProductsSwiper = new Swiper('.relate-products', {
    modules: [Navigation],
    direction: 'horizontal',
    slidesPerView: 6, // Show 3 cards at a time
    spaceBetween: 12, // Space between cards
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      360: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      992: {
        slidesPerView: 4
      },
      1200: {
        slidesPerView: 5
      },
      1470: {
        slidesPerView: 6
      }
    }
  })

  const promoSliderSwiper = new Swiper('.promo-slider', {
    modules: [Navigation],
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 12, // Space between cards
    loop: true,
    autoplay: {
      delay: 800,
      disableOnInteraction: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  })

  const clientsSliderSwiper = new Swiper('.clients-slider-container', {
    modules: [Navigation],
    direction: 'horizontal',
    slidesPerView: 2,
    spaceBetween: 12, // Space between cards
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      360: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      992: {
        slidesPerView: 4
      }
    }
  })

})



